'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = compose;

var _lang = require('./lang');

function compose(funcs) {
  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }
  var first = funcs.shift();
  return function () {
    return funcs.reduce(function (composed, func) {
      if ((0, _lang.isFunction)(func)) {
        return func(composed);
      }
      return func;
    }, first.apply(undefined, arguments));
  };
}
module.exports = exports['default'];